export const TEXTS = {
  MODAL_TITLE: 'Телевизор',
  SUBTITLE: 'Установите приложение «Звук Бизнес» на телевизоре:',

  TURN_ON: 'Включите телевизор и нажмите кнопку «Домой» (Home) на пульте, чтобы оказаться на главном экране.',

  STORES: 'Откройте магазин приложений. В зависимости от модели телевизора он может называться:',
  GOOGLE_PLAY: 'Google Play Маркет (чаще всего)',
  PLAY_STORE: 'Play Store',
  APP_GALLERY: 'Магазин приложений',
  APPS: 'Apps',

  CHOOSE:
    'В открывшемся магазине найдите строку поиска (обычно она находится вверху или обозначена значком лупы). Введите название приложения «Звук Бизнес».',

  SELECT: 'В результатах поиска выберите наше приложение и нажмите кнопку «Установить».',

  SUCCESS_BUTTON: 'Далее',
  CANCEL_BUTTON: 'Назад',
};
